import type { TOC } from '@ember/component/template-only';

import ClientsPerformanceComponent from 'webapp/components/clients/performance';
import NoResultsClientsPerformanceComponent from 'webapp/components/no-results/clients-performance';
import type ClientsPerformanceController from 'webapp/controllers/clients/performance';

interface Args {
	controller: ClientsPerformanceController;
}

const ClientsPerformanceRouteTemplate: TOC<Args> = <template>
	{{#if @controller.clients}}

		<ClientsPerformanceComponent
			@model={{@controller.clients}}
			@onAdd={{@controller.createNewClient}}
		/>

	{{else}}

		<NoResultsClientsPerformanceComponent @onCreate={{@controller.createNewClient}} />

	{{/if}}
</template>;

export default ClientsPerformanceRouteTemplate;
